import { useTranslation } from "react-i18next";
import { VIEW_TYPES } from "../../../../../config/view/types";
import useViewDataObject from "../../../../../hooks/redux/useViewDataObject";
import React, { useCallback } from "react";
import { getServiceDefinitions } from "../../../../../axios/api/services";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import ViewPageWrapper from "../../../contacts/ViewPageWrapper";
import ServiceDefinitionsListTable from "./ServiceDefinitionsListTable";

const ServiceDefinitionsManagement = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.SERVICE_DEFINITION_EDIT;
  const { object, data: serviceDefinitions } = useViewDataObject(viewType);
  const serviceFn = useCallback(getServiceDefinitions(), []);

  return (
    <PageWrapper title={t("t.page.serviceDefinitions.edit")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {serviceDefinitions && (
          <ServiceDefinitionsListTable serviceDefinitions={serviceDefinitions}></ServiceDefinitionsListTable>
        )}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default ServiceDefinitionsManagement;
